import React, { useState } from "react";

import { cn } from "@/utils/shadcn-ui";

import { Tooltip } from "../base/tooltip";
import { TooltipModel } from "./utils";

export function ValidationTooltip({
  model,
  children,
  className,
}: {
  model: TooltipModel;
  children: React.ReactNode;
  className?: string;
}) {
  const [hover, setHover] = useState(false);
  const show = (model.forceOpen || hover) && !!model.message;

  return (
    <Tooltip content={model.message} open={show} onOpenChange={setHover}>
      {/* max-w-full applies whatever the wrapper class is: the wrapper
          shrink-wraps to the field's preferred width (e.g. an explicit
          `width={330}`), which otherwise overflows a narrower column and
          defeats the field's own `max-width: 100%`. */}
      <div className={cn(className ?? "inline-block relative", "max-w-full")}>
        {children}
      </div>
    </Tooltip>
  );
}
